// Cómo se escriben los números de las métricas — ADR-2026-10-06-metricas-de-tienda-online.

/** "$1.284.500" — la plata completa, para tablas y tooltips. */
export function pesos(n: number): string {
  return `$${Math.round(n).toLocaleString('es-AR')}`;
}

/** "$1,3 M" / "$845 mil" / "$9.800" — para tarjetas y ejes, donde el número entero no entra. */
export function pesosCortos(n: number): string {
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toLocaleString('es-AR', { maximumFractionDigits: 1 })} M`;
  if (abs >= 10_000) return `$${Math.round(n / 1000).toLocaleString('es-AR')} mil`;
  return pesos(n);
}

export function numero(n: number): string {
  return Math.round(n).toLocaleString('es-AR');
}

export function porcentaje(p: number, decimales = 1): string {
  return `${(p * 100).toLocaleString('es-AR', { maximumFractionDigits: decimales })}%`;
}

/**
 * La variación contra el período anterior. `null` cuando antes no hubo nada: un "+∞%"
 * no le dice nada a nadie.
 */
export function variacion(actual: number, anterior: number): number | null {
  if (anterior === 0) return null;
  return (actual - anterior) / anterior;
}

/** "5 oct" — el día de un punto de la serie. */
export function diaCorto(iso: string): string {
  return new Date(`${iso}T00:00:00`).toLocaleDateString('es-AR', { day: 'numeric', month: 'short' }).replace('.', '');
}

/**
 * Los días del período (`YYYY-MM-DD`, en hora de Argentina), terminando hoy: las fechas del
 * gráfico de visitas cuando Mercado Libre no dejó leer las ventas (que traen las suyas).
 */
export function diasDelPeriodo(dias: number, ahora = new Date()): string[] {
  const hoyArg = new Date(ahora.getTime() - 3 * 60 * 60_000);
  return Array.from({ length: dias }, (_, i) => {
    const d = new Date(hoyArg.getTime() - (dias - 1 - i) * 24 * 60 * 60_000);
    return d.toISOString().slice(0, 10);
  });
}
